import { loadOptions } from '../../versa/formset.js';

/** Status do pacote Dose Certa (inbox TechHub CEBAF). */
export default function (...args)
{
	return {
		options: [
			{ value: 'received', label: 'Na fila' },
			{ value: 'processing', label: 'Processando' },
			{ value: 'done', label: 'Promovido' },
			{ value: 'error', label: 'Erro' },
			{ value: 'rejected', label: 'Rejeitado' },
		],
		captureEvents(_this = this)
		{
			loadOptions(this.selector, this.options);
			this.safeProtoCall(_this);
		}
	};
}
